import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const About = () => {
  return (
    <Box>
      <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'textSecondary'}
        align={'center'}
      >
        
      </Typography>
      <Typography variant="h4" align={'center'} fontWeight={700} gutterBottom>
        FAQS
      </Typography>
      
    </Box>
  );
};

export default About;